webpackJsonp([1],{

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HotTable_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HotTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HotTable_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_45d69272_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_HotTable_vue__ = __webpack_require__(265);
function injectStyle (ssrContext) {
  __webpack_require__(198)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HotTable_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_45d69272_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_HotTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchDatasets_vue__ = __webpack_require__(159);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e241bc5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchDatasets_vue__ = __webpack_require__(271);
function injectStyle (ssrContext) {
  __webpack_require__(270)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchDatasets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e241bc5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchDatasets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntelligentMetadataScanner_vue__ = __webpack_require__(158);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd59d75e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntelligentMetadataScanner_vue__ = __webpack_require__(269);
function injectStyle (ssrContext) {
  __webpack_require__(266)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntelligentMetadataScanner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd59d75e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntelligentMetadataScanner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_dropzone__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_dropzone_dist_vue2Dropzone_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'automated-metadata-scanner',
  components: {
    vueDropzone: __WEBPACK_IMPORTED_MODULE_0_vue2_dropzone___default.a
  },
  data: function data() {
    return {
      showDialog: this.show,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 150,
        dictDefaultMessage: 'Dateien oder Ordner hochladen'
      },
      uploadedFiles: [],
      filesBeingAdded: false,
      search: '',
      selected: [],
      headers: [{
        text: 'Dateiname',
        align: 'left',
        value: 'name'
      }, { text: 'Titel', value: 'title' }, { text: 'Quelle', value: 'source' }, { text: 'Ansprechpartner', value: 'contact' }, { text: 'Sprache', value: 'language' }, { text: 'Datum', value: 'date' }, { text: 'Zuletzt bearbeitet', value: 'lastModified' }]
    };
  },

  methods: {
    fileAdded: function fileAdded(file) {
      console.log('file added', file);
      this.uploadedFiles.push(file);
      var fakeData = {
        title: 'Liste der Berliner Badestellen',
        source: 'Landesamt für Gesundheit und Soziales',
        contact: 'Landesamt für Gesundheit und Soziales',
        description: 'Landesamt für Gesundheit und Soziales',
        language: 'Deutsch',
        date: '2017-08-05'
      };

      for (var p in fakeData) {
        this.uploadedFiles[0][p] = fakeData[p];
      }this.showDialog = true;
    },
    addSelectedFiles: function addSelectedFiles() {
      this.filesBeingAdded = true;

      var that = this;
      setTimeout(function () {
        that.$store.dispatch('demoUploadDatasetMeta').then(function (dataset) {
          that.filesBeingAdded = false;
          that.showDialog = false;
          that.$store.dispatch('loadResource', dataset.id);
        });
      }, 1400);
    }
  },
  props: ['show']
});

/***/ }),

/***/ 159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'searchDatasets',
  computed: {
    datasetsMetaFiltered: function datasetsMetaFiltered() {
      var _this = this;

      return this.datasetsMeta.filter(function (dataset) {
        if (_this.searchDatasetsMeta != null) {
          var result = dataset.name.toLowerCase().includes(_this.searchDatasetsMeta.toLowerCase());
          result += dataset.description.toLowerCase().includes(_this.searchDatasetsMeta.toLowerCase());
          return result;
        }
        return _this.datasetsMeta;
      });
    },
    currentDataset: function currentDataset() {
      return this.$store.getters.getCurrentDataset;
    }
  },
  data: function data() {
    return {
      searchDatasetsMeta: null,
      active: true
    };
  },

  methods: {},
  props: ['loading', 'datasetsMeta', 'showHint']
});

/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_handsontable_official__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SearchDatasets__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    currentDataset: function currentDataset() {
      return this.$store.getters.getCurrentDataset;
    },
    datasetsMeta: function datasetsMeta() {
      return this.$store.getters.getDatasetsMeta;
    },
    loadingDatasetIndicator: function loadingDatasetIndicator() {
      return this.$store.getters.getLoadingDatasetIndicator;
    }
  },
  components: {
    Spreadsheet: __WEBPACK_IMPORTED_MODULE_0_vue_handsontable_official__["default"],
    SearchDatasets: __WEBPACK_IMPORTED_MODULE_1__components_SearchDatasets__["a" /* default */]
  },
  data: function data() {
    return {
      bewertungItems: {
        maschinenlesbarkeit: ['Nicht bekannt', 'Gar nicht bis gering', 'Überwiegend', 'Maschinenlesbar'],
        auffindbarkeit: ['Nicht bekannt', 'Keine Auszeichnung mit Metadaten', 'Nicht-standardisierte Auszeichnung mit Metadaten', 'Standardisierte Auszeichnung mit Metadaten'],
        nutzungsbedingungen: ['Nicht bekannt', 'Privatnutzung durch Dritte zugelassen', 'Nicht-kommerzielle Weiterverwendung', 'Kommerzielle Weiterverwendung'],
        nutzungskosten: ['Nicht bekannt', 'Nutzung nur gegen Geldleistung', 'Nicht-kommerz. Nutzung geldleistungsfrei', 'Kommerzielle Nutzung geldleistungsfrei'],
        verfuegbarkeit: ['Nicht bekannt', 'Undefiniert', 'Definiert, aber begrenzt', 'Definiert und unbegrenzt'],
        offeneStandards: ['Nicht bekannt', 'Proprietäre Formate', 'Standardisierte, aber nicht offene Formate', 'Standardisierte, offene Formate'],
        aktualisierungsrate: ['Nicht bekannt', 'Nein, keine Aktualisierungsrate', 'Ja, Aktualisierungsrate vorhanden'],
        oeffentlichesInteresse: ['Nicht bekannt', 'Geringes Interesse', 'Erhöhtes Interesse', 'Sehr hohes Interesse']
      },
      root: 'test-hot'
    };
  },

  methods: {},
  filters: {
    uppercase: function uppercase(string) {
      string = string.charAt(0).toUpperCase() + string.slice(1);
      string = string.replace(/ae/g, 'ä').replace(/Ae/g, 'Ä');
      string = string.replace(/ue/g, 'ü').replace(/Ue/g, 'Ü');
      string = string.replace(/oe/g, 'ö').replace(/Oe/g, 'Ö');
      string = string.replace(/([A-Z])/g, ' $1').trim();
      return string;
    }
  }
});

/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_handsontable_official__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SearchDatasets__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    currentDataset: function currentDataset() {
      return this.$store.getters.getCurrentDataset;
    },
    datasetsMeta: function datasetsMeta() {
      return this.$store.getters.getDatasetsMeta;
    },
    loadingDatasetIndicator: function loadingDatasetIndicator() {
      return this.$store.getters.getLoadingDatasetIndicator;
    }
  },
  components: {
    Spreadsheet: __WEBPACK_IMPORTED_MODULE_0_vue_handsontable_official__["default"],
    SearchDatasets: __WEBPACK_IMPORTED_MODULE_1__components_SearchDatasets__["a" /* default */]
  },
  data: function data() {
    return {
      loadingColorisingCells: false,
      loadingMergingCells: false,
      colorisedSimilarCells: false,
      mergedSimilarCells: false,
      refreshingTable: false,
      root: 'test-hot'
    };
  },

  methods: {
    coloriseSimilarCells: function coloriseSimilarCells() {
      var table = this.$refs.spread.table;
      var cells = [[0, 1], [1, 1], // Name
      [0, 2], [1, 2], // Bezirk
      [0, 7], [1, 7] // RSS-Name
      ];

      this.loadingColorisingCells = true;
      var that = this;
      setTimeout(function () {
        if (!that.mergedSimilarCells) {
          for (var i = cells.length - 1; i >= 0; i--) {
            table.getCell(cells[i][0], cells[i][1]).style.backgroundColor = 'orange';
            table.getCell(cells[i][0], cells[i][1]).style.fontWeight = 'bold';
          }
        }
        that.loadingColorisingCells = false;
        that.colorisedSimilarCells = true;
      }, 600);
    },
    mergeSimilarCells: function mergeSimilarCells() {
      this.loadingMergingCells = true;

      var that = this;
      setTimeout(function () {
        that.currentDataset.dataset.data.splice(1, 1);
        that.loadingMergingCells = false;
        that.mergeSimilarCells = true;
        that.colorisedSimilarCells = false;
        that.currentDataset.meta.status.stepAufwertung = true;
      }, 600);
    },
    clearFormatting: function clearFormatting() {
      var table = this.$refs.spread.table;

      this.refreshingTable = true;
      var that = this;
      setTimeout(function () {
        table.render();
        that.refreshingTable = false;
      }, 400);
    }
  }
});

/***/ }),

/***/ 162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_handsontable_official__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_IntelligentMetadataScanner__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SearchDatasets__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    currentDataset: function currentDataset() {
      return this.$store.getters.getCurrentDataset;
    },
    datasetsMeta: function datasetsMeta() {
      return this.$store.getters.getDatasetsMeta;
    },
    loadingDatasetIndicator: function loadingDatasetIndicator() {
      return this.$store.getters.getLoadingDatasetIndicator;
    }
  },
  components: {
    Spreadsheet: __WEBPACK_IMPORTED_MODULE_0_vue_handsontable_official__["default"],
    IntelligentMetadataScanner: __WEBPACK_IMPORTED_MODULE_1__components_IntelligentMetadataScanner__["a" /* default */],
    SearchDatasets: __WEBPACK_IMPORTED_MODULE_2__components_SearchDatasets__["a" /* default */]
  },
  data: function data() {
    return {
      loadingColorisingCells: false,
      loadingAnonymisingCells: false,
      colorisedPrivacyCells: false,
      anonymisedPrivacyCells: false,
      refreshingTable: false,
      root: 'test-hot'
    };
  },

  methods: {
    colorisePrivacyCells: function colorisePrivacyCells() {
      var table = this.$refs.spread.table;

      this.loadingColorisingCells = true;
      var numberOfRows = table.countRows() - 1;
      var that = this;
      setTimeout(function () {
        for (var i = numberOfRows; i >= 0; i--) {
          table.getCell(i, 0).style.backgroundColor = 'orange';
          table.getCell(i, 0).style.fontWeight = 'bold';
        }
        that.loadingColorisingCells = false;
        that.colorisedPrivacyCells = true;
      }, 600);
    },
    anonymiseCells: function anonymiseCells() {
      var table = this.$refs.spread.table;

      this.loadingAnonymisingCells = true;
      var numberOfRows = table.countRows() - 1;
      var that = this;
      setTimeout(function () {
        that.currentDataset.dataset.colHeaders.splice(0, 1);
        that.currentDataset.dataset.minRows = 30;
        for (var i = numberOfRows; i >= 0; i--) {
          that.currentDataset.dataset.data[i].splice(0, 1);
        }
        that.loadingAnonymisingCells = false;
        that.colorisedPrivacyCells = false;
        that.anonymisedPrivacyCells = true;

        that.currentDataset.meta.status.stepAnonymisierung = true;
        that.currentDataset.meta.status.visibility = 'Zur Überprüfung freigegeben';
        that.$store.dispatch('addNotification', {
          title: 'Zur Überprüfung freigegeben',
          text: 'Datensatz ' + that.currentDataset.meta.name.substring(0, 10) + '...' + ' wurde zur Überprüfung freigeben.',
          action: '/erfassung/' + that.currentDataset.meta.id
        });
      }, 600);
    },
    clearFormatting: function clearFormatting() {
      var table = this.$refs.spread.table;

      this.refreshingTable = true;
      var that = this;
      setTimeout(function () {
        table.render();
        that.refreshingTable = false;
      }, 400);
    }
  }
});

/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_store__ = __webpack_require__(282);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (to.meta.title) {
    document.title = to.meta.title + ' | Staging Platform';
  } else document.title = 'Staging Platform';

  if (to.params.id) {
    __WEBPACK_IMPORTED_MODULE_4__vuex_store__["a" /* default */].dispatch('loadResource', to.params.id);
  }

  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (__WEBPACK_IMPORTED_MODULE_4__vuex_store__["a" /* default */].getters.getCurrentUser.loggedIn === false) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__vuex_store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(30);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7af88cb0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(186);
function injectStyle (ssrContext) {
  __webpack_require__(181)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7af88cb0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 181:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterArrows_vue__ = __webpack_require__(31);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3067337f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterArrows_vue__ = __webpack_require__(185);
function injectStyle (ssrContext) {
  __webpack_require__(184)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterArrows_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3067337f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterArrows_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 184:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"app":""}},[(_vm.backButton || _vm.nextButton)?_c('v-layout',{staticClass:"ma-0"},[_c('v-flex',{staticClass:"pa-0",attrs:{"xs6":""}},[(_vm.backButton)?_c('v-list',{staticClass:"blue py-0",attrs:{"dark":""}},[_c('v-list-tile',{attrs:{"ripple":"","to":{ name: _vm.backButton, params: { id: _vm.currentDataset.meta.id } }}},[_c('v-icon',{staticClass:"mr-5 hidden-xs-only",attrs:{"dark":""}},[_vm._v("arrow_back")]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-sub-title',[_vm._v("Zurück")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(_vm.backButton))])],1)],1)],1):_c('v-list',{staticClass:"blue darken--2 py-0",attrs:{"dark":""}},[_c('v-list-tile')],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-0",attrs:{"xs6":""}},[(_vm.nextButton)?_c('v-list',{staticClass:"primary py-0",attrs:{"dark":""}},[_c('v-list-tile',{attrs:{"ripple":"","to":{ name: _vm.nextButton, params: { id: _vm.currentDataset.meta.id } }}},[_c('v-list-tile-content',[_c('v-list-tile-sub-title',{staticClass:"text-xs-right"},[_vm._v("Weiter")]),_vm._v(" "),_c('v-list-tile-title',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm.nextButton))])],1),_vm._v(" "),_c('v-icon',{staticClass:"ml-5 hidden-xs-only",attrs:{"dark":""}},[_vm._v("arrow_forward")])],1)],1):_c('v-list',{staticClass:"primary py-0",attrs:{"dark":""}},[_c('v-list-tile')],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-navigation-drawer',{attrs:{"persistent":"","enable-resize-watcher":"","app":"","mini-variant":_vm.miniVariant},on:{"update:miniVariant":function($event){_vm.miniVariant=$event}},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-toolbar',{staticClass:"transparent",attrs:{"flat":""}},[_c('v-list',[(_vm.currentUser.userId)?_c('v-list-tile',{attrs:{"avatar":"","tag":"div"}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":_vm.currentUser.avatar}})]),_vm._v(" "),(_vm.currentUser.userId)?_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.currentUser.fullname))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.currentUser.email))])],1):_vm._e(),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.miniVariant = !_vm.miniVariant}}},[_c('v-icon',[_vm._v("chevron_left")])],1)],1)],1):_c('v-list-tile',{attrs:{"ripple":""}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("account_circle")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Nicht angemeldet")])],1)],1)],1)],1),_vm._v(" "),_c('v-list',{staticClass:"pt-0"},[_c('v-divider'),_vm._v(" "),_vm._l((_vm.drawerItems),function(item){return _c('v-list-tile',{key:item.title,attrs:{"to":item.link,"ripple":""}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))])],1)],1)}),_vm._v(" "),_vm._l((_vm.drawerTools),function(item){return _c('v-list-group',{key:item.title,attrs:{"value":item.active}},[_c('v-list-tile',{attrs:{"slot":"item"},on:{"click":function($event){}},slot:"item"},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.action))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-icon',[_vm._v("keyboard_arrow_down")])],1)],1),_vm._v(" "),_vm._l((item.items),function(subItem){return _c('v-list-tile',{key:subItem.title,attrs:{"to":subItem.link + _vm.currentDataset.meta.id}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(subItem.title))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(subItem.action))])],1)],1)})],2)}),_vm._v(" "),(_vm.isReferatsleitung)?_c('v-list-tile',{attrs:{"ripple":"","disabled":!_vm.currentDataset.meta.id},on:{"click":function($event){$event.stopPropagation();_vm.sheet = true}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("assignment_turned_in")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Zur Veröffentlichung freigeben")])],1)],1):_vm._e(),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{on:{"click":_vm.logoutUser}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("exit_to_app")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Abmelden")])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){$event.stopPropagation();_vm.miniVariant = !_vm.miniVariant}}},[_c('v-list-tile-action',[_c('v-icon',{staticClass:"grey--text"},[_vm._v(_vm._s(_vm.miniVariant ? 'chevron_right' : 'chevron_left'))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"grey--text"},[_vm._v("Menü minimieren")])],1)],1)],2),_vm._v(" "),_c('v-list',{staticClass:"ma-4",staticStyle:{"width":"50%","position":"absolute","bottom":"160px"}},[_c('a',{attrs:{"href":"/datenschutzbestimmungen","target":"_blank"}},[_vm._v("Datenschutz")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"/impressum"}},[_vm._v("Impressum")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"/kontakt"}},[_vm._v("Kontakt")])]),_vm._v(" "),_c('img',{staticClass:"ma-4",staticStyle:{"width":"50%","position":"absolute","bottom":"75px"},attrs:{"src":__webpack_require__(187)}}),_vm._v(" "),_c('img',{staticClass:"ma-4",staticStyle:{"width":"50%","position":"absolute","bottom":"0"},attrs:{"src":__webpack_require__(188)}})],1),_vm._v(" "),_c('router-view',{attrs:{"app":""}}),_vm._v(" "),_c('footer-arrows'),_vm._v(" "),_c('v-bottom-sheet',{model:{value:(_vm.sheet),callback:function ($$v) {_vm.sheet=$$v},expression:"sheet"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('h4',{staticClass:"headline mb-0"},[_vm._v("Datensatz zur "),_c('b',[_vm._v("Veröffentlichung")]),_vm._v(" freigeben")]),_vm._v(" "),_c('div',[_vm._v("Sind Sie sicher, dass Sie diesen Datensatz zur Veröffentlichung freigeben möchten?")])])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","color":"primary","loading":_vm.loadingIndicator},on:{"click":_vm.publishDataset}},[_vm._v("Freigeben")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.sheet = false}}},[_vm._v("Abbrechen")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Der Datensatz wurde erfolgreich veröffentlicht.")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Schließen")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-rgb-web.e8efa1b.jpg";

/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fokus_logo_farbig.01980e5.png";

/***/ }),

/***/ 190:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(33);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69bb017f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(192);
function injectStyle (ssrContext) {
  __webpack_require__(191)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69bb017f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 191:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"login"},[_c('v-toolbar',{staticClass:"indigo",attrs:{"dark":"","fixed":"","app":""}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.$root.$children[0]._data.drawer = !_vm.$root.$children[0]._data.drawer}}}),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Staging platform")])],1),_vm._v(" "),_c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","xl4":"","lg6":"","sm8":""}},[_c('v-card',{staticClass:"elevation-8"},[_c('v-card-title',[_c('v-flex',{attrs:{"xs12":"","align-end":"","flexbox":""}},[_c('img',{staticStyle:{"height":"40px","margin-right":"20px"},attrs:{"src":"https://ssl.gstatic.com/images/branding/product/1x/avatar_circle_blue_512dp.png"}}),_vm._v(" "),_c('span',{staticClass:"title",staticStyle:{"padding":"10px 0"}},[_vm._v("Melden Sie sich an, um fortzufahren")])])],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"padding-top":"0"}},[_c('div',[_c('span',{staticClass:"body-2 grey--text"},[_vm._v("Anmelden als...")]),_c('br'),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.users),function(user){return [(user.divider)?_c('v-divider',{attrs:{"inset":user.inset}}):_c('v-list-tile',{key:user.title,attrs:{"avatar":""},on:{"click":function($event){_vm.login(user.userId)}}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":user.avatar}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(user.fullname))]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('span',{staticClass:"grey--text text--darken-2"},[_vm._v(_vm._s(user.email))])])],1)],1)]})],2),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_vm._v("Mit einem anderen Konto anmelden")])],1)])],1),_vm._v(" "),_c('v-spacer')],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 193:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(34);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_288855b7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(195);
function injectStyle (ssrContext) {
  __webpack_require__(194)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_288855b7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 194:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('v-toolbar',{staticClass:"primary elevation-0",attrs:{"dark":"","fixed":"","app":"","extended":""}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.$root.$children[0]._data.drawer = !_vm.$root.$children[0]._data.drawer}}}),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Dashboard | Staging Platform")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.isReferatsleitung)?_c('v-menu',{attrs:{"offset-x":"","close-on-content-click":false,"nudge-width":200,"max-width":500},model:{value:(_vm.showNotificationCenter),callback:function ($$v) {_vm.showNotificationCenter=$$v},expression:"showNotificationCenter"}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-badge',{attrs:{"overlap":"","color":"red"}},[(_vm.numberOfNotifications)?_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(_vm.numberOfNotifications))]):_vm._e(),_vm._v(" "),_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mail")])],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-title',{staticStyle:{"padding-bottom":"0"}},[_c('div',{staticClass:"title"},[_vm._v("Benachrichtigungen")])]),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[(!_vm.numberOfNotifications)?_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("\n              Keine Benachrichtigungen\n            ")])],1):_vm._e(),_vm._v(" "),_vm._l((_vm.notifications),function(notification,index){return [_c('v-list-tile',{key:notification.text,attrs:{"to":notification.action}},[_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(notification.title)}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s(notification.text)}})],1),_vm._v(" "),_c('v-list-tile-action',{on:{"click":function($event){_vm.removeNotification(index)}}},[_c('v-btn',{attrs:{"icon":"","ripple":""}},[_c('v-icon',{staticClass:"grey--text text--lighten-1"},[_vm._v("close")])],1)],1)],1)]})],2),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.showNotificationCenter = false}}},[_vm._v("Schließen")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"solo":"","prepend-icon":"search","placeholder":"Suchen..."}}),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("refresh")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("help")])],1)],1),_vm._v(" "),_c('v-content',[_c('v-container',{attrs:{"grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"card--flex-toolbar",staticStyle:{"margin-top":"-76px","z-index":"3"}},[_c('v-toolbar',{attrs:{"card":"","prominent":""}},[_c('v-toolbar-title',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.isReferatsleitung ? 'Datensätze meiner Organisationseinheit' : 'Meine Datensätze'))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("add")]),_vm._v("\n                Datensatz erfassen\n              ")],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("search")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.viewAsGrid = !_vm.viewAsGrid}}},[_c('v-icon',[_vm._v("apps")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("more_vert")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',{staticClass:"body-2 grey--text"},[_vm._v("Wählen Sie einen Datensatz, um fortzufahren. Verwenden Sie den \"+\"-Button, um einen neuen Datensatz hinzuzufügen.")]),_vm._v(" "),(!_vm.viewAsGrid)?_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.datasetsMeta,"selected-key":"name","rows-per-page-text":'Zeilen pro Seite',"select-all":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('v-checkbox',{attrs:{"primary":"","hide-details":""},model:{value:(props.selected),callback:function ($$v) {_vm.$set(props, "selected", $$v)},expression:"props.selected"}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("ellipsis")(props.item.name,40)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.date.modified))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-btn',{attrs:{"icon":"","to":'/erfassung/' + props.item.id}},[(props.item.status.stepErfassung)?_c('v-icon',[_vm._v("check_circle")]):_c('v-icon',[_vm._v("highlight_off")])],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-btn',{attrs:{"icon":"","to":'/bewertung/' + props.item.id}},[(props.item.status.stepBewertung)?_c('v-icon',[_vm._v("check_circle")]):_c('v-icon',[_vm._v("highlight_off")])],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-btn',{attrs:{"icon":"","to":'/aufwertung/' + props.item.id}},[(props.item.status.stepAufwertung)?_c('v-icon',[_vm._v("check_circle")]):_c('v-icon',[_vm._v("highlight_off")])],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-btn',{attrs:{"icon":"","to":'/anonymisierung/' + props.item.id}},[(props.item.status.stepAnonymisierung)?_c('v-icon',[_vm._v("check_circle")]):_c('v-icon',[_vm._v("highlight_off")])],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.status.visibility))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-btn',{attrs:{"icon":"","flat":"","to":'/erfassung/' + props.item.id}},[_c('v-icon',[_vm._v("edit")])],1)],1)]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}):_vm._e(),_vm._v(" "),(_vm.viewAsGrid)?_c('v-container',{staticStyle:{"padding-top":"0"},attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.datasetsMeta),function(dataset){return _c('v-flex',{key:dataset.id,attrs:{"sm4":""}},[_c('v-card',{attrs:{"hover":""}},[_c('v-card-title',[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v(_vm._s(_vm._f("ellipsis")(dataset.name,40)))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm._f("ellipsis")(dataset.description,70)))])])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","primary":"","to":'/erfassung/' + dataset.id}},[_vm._v("View dataset")])],1)],1)],1)}))],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('v-card',{staticClass:"blue white--text",attrs:{"hover":"","to":'/erfassung/'}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v("Erfassung")])])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs5":""}},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("rate_review")])],1)],1),_vm._v(" "),_c('div',[_vm._v("Erfassen Sie neue Datensätze oder bearbeiten Sie die Metadaten von bereits erfassten Datensätzen.")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('v-card',{staticClass:"blue lighten-2 white--text",attrs:{"hover":"","to":'/bewertung/'}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v("Bewertung")])])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs5":""}},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("assessment")])],1)],1),_vm._v(" "),_c('div',[_vm._v("Führen Sie Bewertungen für erfasste Datensätze anhand mehrerer Kriterien durch.")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('v-card',{staticClass:"blue darken-2 white--text",attrs:{"hover":"","to":'/aufwertung/'}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v("Aufwertung")])])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs5":""}},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("chrome_reader_mode")])],1)],1),_vm._v(" "),_c('div',[_vm._v("Mittels dieser Funktion können Sie Datensätze aufwerten, indem Sie bspw. Duplikate identifizieren und entfernen.")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('v-card',{staticClass:"blue-grey white--text",attrs:{"hover":"","to":'/anonymisierung/'}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v("Anonymisierung")])])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs5":""}},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("fingerprint")])],1)],1),_vm._v(" "),_c('div',[_vm._v("Verwenden Sie diese Funktion, um personenbezogene Daten zu identifizieren und entfernen.")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 196:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Erfassung_vue__ = __webpack_require__(35);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f2c8d50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Erfassung_vue__ = __webpack_require__(272);
function injectStyle (ssrContext) {
  __webpack_require__(197)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Erfassung_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f2c8d50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Erfassung_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 197:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 198:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 37,
	"./af.js": 37,
	"./ar": 38,
	"./ar-dz": 39,
	"./ar-dz.js": 39,
	"./ar-kw": 40,
	"./ar-kw.js": 40,
	"./ar-ly": 41,
	"./ar-ly.js": 41,
	"./ar-ma": 42,
	"./ar-ma.js": 42,
	"./ar-sa": 43,
	"./ar-sa.js": 43,
	"./ar-tn": 44,
	"./ar-tn.js": 44,
	"./ar.js": 38,
	"./az": 45,
	"./az.js": 45,
	"./be": 46,
	"./be.js": 46,
	"./bg": 47,
	"./bg.js": 47,
	"./bm": 48,
	"./bm.js": 48,
	"./bn": 49,
	"./bn.js": 49,
	"./bo": 50,
	"./bo.js": 50,
	"./br": 51,
	"./br.js": 51,
	"./bs": 52,
	"./bs.js": 52,
	"./ca": 53,
	"./ca.js": 53,
	"./cs": 54,
	"./cs.js": 54,
	"./cv": 55,
	"./cv.js": 55,
	"./cy": 56,
	"./cy.js": 56,
	"./da": 57,
	"./da.js": 57,
	"./de": 58,
	"./de-at": 59,
	"./de-at.js": 59,
	"./de-ch": 60,
	"./de-ch.js": 60,
	"./de.js": 58,
	"./dv": 61,
	"./dv.js": 61,
	"./el": 62,
	"./el.js": 62,
	"./en-au": 63,
	"./en-au.js": 63,
	"./en-ca": 64,
	"./en-ca.js": 64,
	"./en-gb": 65,
	"./en-gb.js": 65,
	"./en-ie": 66,
	"./en-ie.js": 66,
	"./en-nz": 67,
	"./en-nz.js": 67,
	"./eo": 68,
	"./eo.js": 68,
	"./es": 69,
	"./es-do": 70,
	"./es-do.js": 70,
	"./es-us": 71,
	"./es-us.js": 71,
	"./es.js": 69,
	"./et": 72,
	"./et.js": 72,
	"./eu": 73,
	"./eu.js": 73,
	"./fa": 74,
	"./fa.js": 74,
	"./fi": 75,
	"./fi.js": 75,
	"./fo": 76,
	"./fo.js": 76,
	"./fr": 77,
	"./fr-ca": 78,
	"./fr-ca.js": 78,
	"./fr-ch": 79,
	"./fr-ch.js": 79,
	"./fr.js": 77,
	"./fy": 80,
	"./fy.js": 80,
	"./gd": 81,
	"./gd.js": 81,
	"./gl": 82,
	"./gl.js": 82,
	"./gom-latn": 83,
	"./gom-latn.js": 83,
	"./gu": 84,
	"./gu.js": 84,
	"./he": 85,
	"./he.js": 85,
	"./hi": 86,
	"./hi.js": 86,
	"./hr": 87,
	"./hr.js": 87,
	"./hu": 88,
	"./hu.js": 88,
	"./hy-am": 89,
	"./hy-am.js": 89,
	"./id": 90,
	"./id.js": 90,
	"./is": 91,
	"./is.js": 91,
	"./it": 92,
	"./it.js": 92,
	"./ja": 93,
	"./ja.js": 93,
	"./jv": 94,
	"./jv.js": 94,
	"./ka": 95,
	"./ka.js": 95,
	"./kk": 96,
	"./kk.js": 96,
	"./km": 97,
	"./km.js": 97,
	"./kn": 98,
	"./kn.js": 98,
	"./ko": 99,
	"./ko.js": 99,
	"./ky": 100,
	"./ky.js": 100,
	"./lb": 101,
	"./lb.js": 101,
	"./lo": 102,
	"./lo.js": 102,
	"./lt": 103,
	"./lt.js": 103,
	"./lv": 104,
	"./lv.js": 104,
	"./me": 105,
	"./me.js": 105,
	"./mi": 106,
	"./mi.js": 106,
	"./mk": 107,
	"./mk.js": 107,
	"./ml": 108,
	"./ml.js": 108,
	"./mr": 109,
	"./mr.js": 109,
	"./ms": 110,
	"./ms-my": 111,
	"./ms-my.js": 111,
	"./ms.js": 110,
	"./mt": 112,
	"./mt.js": 112,
	"./my": 113,
	"./my.js": 113,
	"./nb": 114,
	"./nb.js": 114,
	"./ne": 115,
	"./ne.js": 115,
	"./nl": 116,
	"./nl-be": 117,
	"./nl-be.js": 117,
	"./nl.js": 116,
	"./nn": 118,
	"./nn.js": 118,
	"./pa-in": 119,
	"./pa-in.js": 119,
	"./pl": 120,
	"./pl.js": 120,
	"./pt": 121,
	"./pt-br": 122,
	"./pt-br.js": 122,
	"./pt.js": 121,
	"./ro": 123,
	"./ro.js": 123,
	"./ru": 124,
	"./ru.js": 124,
	"./sd": 125,
	"./sd.js": 125,
	"./se": 126,
	"./se.js": 126,
	"./si": 127,
	"./si.js": 127,
	"./sk": 128,
	"./sk.js": 128,
	"./sl": 129,
	"./sl.js": 129,
	"./sq": 130,
	"./sq.js": 130,
	"./sr": 131,
	"./sr-cyrl": 132,
	"./sr-cyrl.js": 132,
	"./sr.js": 131,
	"./ss": 133,
	"./ss.js": 133,
	"./sv": 134,
	"./sv.js": 134,
	"./sw": 135,
	"./sw.js": 135,
	"./ta": 136,
	"./ta.js": 136,
	"./te": 137,
	"./te.js": 137,
	"./tet": 138,
	"./tet.js": 138,
	"./th": 139,
	"./th.js": 139,
	"./tl-ph": 140,
	"./tl-ph.js": 140,
	"./tlh": 141,
	"./tlh.js": 141,
	"./tr": 142,
	"./tr.js": 142,
	"./tzl": 143,
	"./tzl.js": 143,
	"./tzm": 144,
	"./tzm-latn": 145,
	"./tzm-latn.js": 145,
	"./tzm.js": 144,
	"./uk": 146,
	"./uk.js": 146,
	"./ur": 147,
	"./ur.js": 147,
	"./uz": 148,
	"./uz-latn": 149,
	"./uz-latn.js": 149,
	"./uz.js": 148,
	"./vi": 150,
	"./vi.js": 150,
	"./x-pseudo": 151,
	"./x-pseudo.js": 151,
	"./yo": 152,
	"./yo.js": 152,
	"./zh-cn": 153,
	"./zh-cn.js": 153,
	"./zh-hk": 154,
	"./zh-hk.js": 154,
	"./zh-tw": 155,
	"./zh-tw.js": 155
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 200;

/***/ }),

/***/ 265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":this.root}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 266:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 268:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-toolbar',{staticClass:"cyan",attrs:{"dark":"","flat":""}},[_c('v-toolbar-title',[_vm._v("Automatische Metadatenerfassung")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("help")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"body-2 grey--text"},[_vm._v("Ziehen Sie die Dateien mit den Datensätzen auf dieses Feld, um die Metadaten automatisch zu erfassen.")]),_vm._v(" "),_c('vue-dropzone',{ref:"myVueDropzone",attrs:{"id":"dropzone","options":_vm.dropzoneOptions},on:{"vdropzone-success":_vm.fileAdded}}),_vm._v(" "),_c('v-dialog',{attrs:{"width":1020,"persistent":""},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Automatische Metadatenerfassung")]),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"body-2 grey--text"},[_vm._v("Folgende Metadaten wurden erkannt. Korrigieren und bestätigen Sie die erfassten Daten, um mit der Bearbeitung fortzufahren.")])]),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.uploadedFiles,"search":_vm.search,"rows-per-page-text":'Zeilen pro Seite',"item-key":"name","select-all":""},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('v-tooltip',{attrs:{"bottom":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v("\n                "+_vm._s(props.header.text)+"\n              ")]),_vm._v(" "),_c('span',[_vm._v("\n                "+_vm._s(props.header.text)+"\n              ")])])]}},{key:"items",fn:function(props){return [_c('td',[_c('v-checkbox',{attrs:{"primary":"","hide-details":""},model:{value:(props.selected),callback:function ($$v) {_vm.$set(props, "selected", $$v)},expression:"props.selected"}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.title))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.source))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.contact))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.language))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.date))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.lastModified))])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"","disabled":!_vm.selected.length,"loading":_vm.filesBeingAdded},nativeOn:{"click":function($event){return _vm.addSelectedFiles($event)}}},[_vm._v("Ausgewählte hinzufügen ("+_vm._s(_vm.selected.length)+")")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.showDialog = false}}},[_vm._v("Abbrechen")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 270:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-toolbar',{staticClass:"cyan",attrs:{"dark":"","flat":""}},[_c('v-text-field',{attrs:{"solo":"","clearable":"","placeholder":"Nach Datensätzen suchen...","prepend-icon":"search"},model:{value:(_vm.searchDatasetsMeta),callback:function ($$v) {_vm.searchDatasetsMeta=$$v},expression:"searchDatasetsMeta"}})],1),_vm._v(" "),_c('v-list',{staticStyle:{"padding":"0"},attrs:{"two-line":""}},[(_vm.showHint)?_c('div',{staticClass:"body-2 grey--text pa-3"},[_vm._v("Wählen Sie einen Datensatz aus, um fortzufahren.")]):_vm._e(),_vm._v(" "),_vm._l((_vm.datasetsMetaFiltered),function(dataset){return (dataset.name)?_c('v-list-tile',{key:dataset.name,attrs:{"to":dataset.id}},[_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(dataset.name)}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"textContent":_vm._s(dataset.description)}})],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"icon":"","ripple":""}},[_c('v-icon',{attrs:{"color":"grey lighten-1"}},[_vm._v("keyboard_arrow_right")])],1)],1)],1):_vm._e()}),_vm._v(" "),(!_vm.datasetsMetaFiltered.length)?_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',[_vm._v("error")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Keine Datensätze gefunden")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Es wurde für Ihren Suchbegriff kein Datensatz gefunden.")])],1)],1):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('v-toolbar',{staticClass:"blue",attrs:{"app":"","fixed":"","dark":""}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.$root.$children[0]._data.drawer = !_vm.$root.$children[0]._data.drawer}}}),_vm._v(" "),(_vm.currentDataset.meta.name)?_c('v-toolbar-title',[_vm._v("Erfassung: "+_vm._s(_vm.currentDataset.meta.name))]):_c('v-toolbar-title',[_vm._v("Erfassung")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("search")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("more_vert")])],1)],1),_vm._v(" "),(_vm.currentDataset.meta.name)?_c('v-content',[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":"","lg3":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('search-datasets',{attrs:{"loading":_vm.loadingDatasetIndicator,"datasetsMeta":_vm.datasetsMeta.data}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('intelligent-metadata-scanner',{attrs:{"show":_vm.metaDataUploadDialog}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm8":"","lg9":""}},[_c('v-card',[_c('v-tabs',{attrs:{"centered":"","grow":"","dark":""}},[_c('v-tabs-bar',{staticClass:"cyan"},[_c('v-tabs-item',{attrs:{"href":'#default-view',"ripple":""}},[_vm._v("Vereinfachte Ansicht")]),_vm._v(" "),_c('v-tabs-item',{attrs:{"href":'#expert-view',"ripple":""}},[_vm._v("Expertenansicht")]),_vm._v(" "),_c('v-tabs-slider',{staticClass:"yellow"})],1),_vm._v(" "),(_vm.loadingDatasetIndicator)?_c('v-card-text',{staticStyle:{"height":"490px"}},[_c('v-progress-circular',{staticClass:"loading-dataset-indicator",attrs:{"indeterminate":""}})],1):_vm._e(),_vm._v(" "),_c('v-tabs-items',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loadingDatasetIndicator),expression:"!loadingDatasetIndicator"}]},[_c('v-tabs-content',{attrs:{"id":'default-view'}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v("Erfassung")]),_vm._v(" "),_c('div',{staticClass:"body-2 grey--text"},[_vm._v("Füllen Sie die Felder aus, um den Datensatz zu erfassen. Verwenden Sie die Expertenansicht, um mehrere Meta-Datensätze zu bearbeiten.")])])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm6":""}},[_c('v-text-field',{attrs:{"label":"Name des Datensatzes"},model:{value:(_vm.currentDataset.meta.name),callback:function ($$v) {_vm.$set(_vm.currentDataset.meta, "name", $$v)},expression:"currentDataset.meta.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm6":""}},[_c('v-text-field',{attrs:{"label":"Quelle"},model:{value:(_vm.currentDataset.meta.source),callback:function ($$v) {_vm.$set(_vm.currentDataset.meta, "source", $$v)},expression:"currentDataset.meta.source"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm6":""}},[_c('v-dialog',{attrs:{"persistent":"","lazy":"","full-width":""}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Erstellt am","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.currentDataset.meta.date.created),callback:function ($$v) {_vm.$set(_vm.currentDataset.meta.date, "created", $$v)},expression:"currentDataset.meta.date.created"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"first-day-of-week":0,"locale":"de-de","scrollable":"","actions":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("Speichern")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":cancel}},[_vm._v("Abbrechen")])],1)]}}]),model:{value:(_vm.currentDataset.meta.date.created),callback:function ($$v) {_vm.$set(_vm.currentDataset.meta.date, "created", $$v)},expression:"currentDataset.meta.date.created"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"sm6":""}},[_c('v-dialog',{attrs:{"persistent":"","lazy":"","full-width":""}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Zuletzt verändert","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.currentDataset.meta.date.modified),callback:function ($$v) {_vm.$set(_vm.currentDataset.meta.date, "modified", $$v)},expression:"currentDataset.meta.date.modified"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"first-day-of-week":0,"locale":"de-de","scrollable":"","actions":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("Speichern")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":cancel}},[_vm._v("Abbrechen")])],1)]}}]),model:{value:(_vm.currentDataset.meta.date.modified),callback:function ($$v) {_vm.$set(_vm.currentDataset.meta.date, "modified", $$v)},expression:"currentDataset.meta.date.modified"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm6":""}},[_c('v-text-field',{attrs:{"label":"Sprache"},model:{value:(_vm.currentDataset.meta.language),callback:function ($$v) {_vm.$set(_vm.currentDataset.meta, "language", $$v)},expression:"currentDataset.meta.language"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm6":""}},[_c('v-text-field',{attrs:{"label":"Ansprechpartner"},model:{value:(_vm.currentDataset.meta.contact),callback:function ($$v) {_vm.$set(_vm.currentDataset.meta, "contact", $$v)},expression:"currentDataset.meta.contact"}})],1)],1),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Beschreibung des Datensatzes","hint":"Geben Sie eine kurze Beschreibung des Datensatzes an","multi-line":""},model:{value:(_vm.currentDataset.meta.description),callback:function ($$v) {_vm.$set(_vm.currentDataset.meta, "description", $$v)},expression:"currentDataset.meta.description"}})],1)],1),_vm._v(" "),_c('v-tabs-content',{attrs:{"id":'expert-view'}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v("Erfassung")]),_vm._v(" "),_c('div',{staticClass:"body-2 grey--text"},[_vm._v("Füllen Sie die Felder aus, um den Datensatz zu erfassen. Verwenden Sie die Expertenansicht, um mehrere Meta-Datensätze zu bearbeiten.")])])]),_vm._v(" "),_c('v-card-text',[_c('Spreadsheet',{attrs:{"root":_vm.root,"settings":_vm.datasetsMeta}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","color":"primary"}},[_vm._v("Änderungen speichern")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""}},[_vm._v("Abbrechen")])],1)],1)],1)],1)],1)],1):_c('v-content',[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('search-datasets',{attrs:{"loading":_vm.loadingDatasetIndicator,"datasetsMeta":_vm.datasetsMeta.data,"show-hint":true}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('intelligent-metadata-scanner',{attrs:{"show":_vm.metaDataUploadDialog}})],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bewertung_vue__ = __webpack_require__(160);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a8fc186_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bewertung_vue__ = __webpack_require__(275);
function injectStyle (ssrContext) {
  __webpack_require__(274)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bewertung_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a8fc186_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bewertung_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 274:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('v-toolbar',{staticClass:"cyan",attrs:{"app":"","fixed":"","dark":""}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.$root.$children[0]._data.drawer = !_vm.$root.$children[0]._data.drawer}}}),_vm._v(" "),(_vm.currentDataset.meta.name)?_c('v-toolbar-title',[_vm._v("Bewertung: "+_vm._s(_vm.currentDataset.meta.name))]):_c('v-toolbar-title',[_vm._v("Bewertung")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("search")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("more_vert")])],1)],1),_vm._v(" "),(_vm.currentDataset.meta.name)?_c('v-content',[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":"","lg3":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('search-datasets',{attrs:{"loading":_vm.loadingDatasetIndicator,"datasetsMeta":_vm.datasetsMeta.data}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm8":"","lg9":""}},[_c('v-card',[_c('v-tabs',{attrs:{"centered":"","grow":"","dark":""}},[_c('v-tabs-bar',{staticClass:"cyan"},[_c('v-tabs-item',{attrs:{"href":'#default-view',"ripple":""}},[_vm._v("Vereinfachte Ansicht")]),_vm._v(" "),_c('v-tabs-item',{attrs:{"href":'#expert-view',"ripple":""}},[_vm._v("Expertenansicht")]),_vm._v(" "),_c('v-tabs-slider',{staticClass:"yellow"})],1),_vm._v(" "),(_vm.loadingDatasetIndicator)?_c('v-card-text',{staticStyle:{"height":"490px"}},[_c('v-progress-circular',{staticClass:"loading-dataset-indicator",attrs:{"indeterminate":""}})],1):_vm._e(),_vm._v(" "),_c('v-tabs-items',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loadingDatasetIndicator),expression:"!loadingDatasetIndicator"}]},[_c('v-tabs-content',{attrs:{"id":'default-view'}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v("Bewertung")]),_vm._v(" "),_c('div',{staticClass:"body-2 grey--text"},[_vm._v("Füllen Sie die Felder aus, um eine Bewertung für den Datensatz vorzunehmen. Verwenden Sie die Expertenansicht, um mehrere Meta-Datensätze zu bearbeiten.")])])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.bewertungItems),function(items,itemName,index){return _c('v-flex',{key:index,attrs:{"sm6":""}},[_c('v-select',{attrs:{"items":items,"label":_vm._f("uppercase")(itemName),"item-value":"'Noch offen'"},model:{value:(_vm.currentDataset.meta.bewertung[itemName]),callback:function ($$v) {_vm.$set(_vm.currentDataset.meta.bewertung, itemName, $$v)},expression:"currentDataset.meta.bewertung[itemName]"}})],1)}))],1)],1),_vm._v(" "),_c('v-tabs-content',{attrs:{"id":'expert-view'}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v("Bewertung")]),_vm._v(" "),_c('div',{staticClass:"body-2 grey--text"},[_vm._v("Füllen Sie die Felder aus, um eine Bewertung für den Datensatz vorzunehmen. Verwenden Sie die Expertenansicht, um mehrere Meta-Datensätze zu bearbeiten.")])])]),_vm._v(" "),_c('v-card-text',[_c('Spreadsheet',{attrs:{"root":_vm.root,"data":_vm.datasetsMeta.data}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","color":"primary"}},[_vm._v("Änderungen speichern")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""}},[_vm._v("Abbrechen")])],1)],1)],1)],1)],1)],1):_c('v-content',[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('search-datasets',{attrs:{"loading":_vm.loadingDatasetIndicator,"datasetsMeta":_vm.datasetsMeta.data,"show-hint":true}})],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aufwertung_vue__ = __webpack_require__(161);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07d805de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aufwertung_vue__ = __webpack_require__(278);
function injectStyle (ssrContext) {
  __webpack_require__(277)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aufwertung_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07d805de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aufwertung_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 277:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('v-toolbar',{staticClass:"blue darken-2",attrs:{"app":"","fixed":"","dark":""}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.$root.$children[0]._data.drawer = !_vm.$root.$children[0]._data.drawer}}}),_vm._v(" "),(_vm.currentDataset.meta.name)?_c('v-toolbar-title',[_vm._v("Aufwertung: "+_vm._s(_vm.currentDataset.meta.name))]):_c('v-toolbar-title',[_vm._v("Aufwertung")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("search")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("more_vert")])],1)],1),_vm._v(" "),(_vm.currentDataset.meta.name)?_c('v-content',[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":"","lg3":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('search-datasets',{attrs:{"loading":_vm.loadingDatasetIndicator,"datasetsMeta":_vm.datasetsMeta.data}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm8":"","lg9":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"cyan elevation-0",attrs:{"dark":""}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Aufwertung")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","loading":_vm.loadingColorisingCells},nativeOn:{"click":function($event){return _vm.coloriseSimilarCells($event)}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("select_all")]),_vm._v("\n                Ähnliche Zellen markieren\n              ")],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","disabled":!_vm.colorisedSimilarCells,"loading":_vm.loadingMergingCells},nativeOn:{"click":function($event){return _vm.mergeSimilarCells($event)}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("tab_unselected")]),_vm._v("\n                Markierte zusammenfassen\n              ")],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","loading":_vm.refreshingTable},nativeOn:{"click":function($event){return _vm.clearFormatting($event)}}},[_c('v-icon',[_vm._v("refresh")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("more_vert")])],1)],1),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticClass:"body-2 grey--text"},[_vm._v("Wählen Sie eine der Funktionen aus, um fortzufahren.")])])]),_vm._v(" "),(_vm.loadingDatasetIndicator)?_c('v-card-text',{staticStyle:{"height":"500px"}},[_c('v-progress-circular',{staticClass:"loading-dataset-indicator",attrs:{"indeterminate":""}})],1):(!_vm.currentDataset.dataset.data)?_c('v-card-text',{staticStyle:{"height":"500px"}},[_vm._v("\n              Keine Daten\n            ")]):_c('v-card-text',[_c('Spreadsheet',{ref:"spread",attrs:{"root":_vm.root,"settings":_vm.currentDataset.dataset}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","color":"primary"}},[_vm._v("Änderungen speichern")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""}},[_vm._v("Abbrechen")])],1)],1)],1)],1)],1)],1):_c('v-content',[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('search-datasets',{attrs:{"loading":_vm.loadingDatasetIndicator,"datasetsMeta":_vm.datasetsMeta.data,"show-hint":true}})],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Anonymisierung_vue__ = __webpack_require__(162);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5103146_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Anonymisierung_vue__ = __webpack_require__(281);
function injectStyle (ssrContext) {
  __webpack_require__(280)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Anonymisierung_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5103146_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Anonymisierung_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 280:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('v-toolbar',{staticClass:"blue-grey",attrs:{"app":"","fixed":"","dark":""}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.$root.$children[0]._data.drawer = !_vm.$root.$children[0]._data.drawer}}}),_vm._v(" "),(_vm.currentDataset.meta.name)?_c('v-toolbar-title',[_vm._v("Anonymisierung: "+_vm._s(_vm.currentDataset.meta.name))]):_c('v-toolbar-title',[_vm._v("Anonymisierung")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("search")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("more_vert")])],1)],1),_vm._v(" "),(_vm.currentDataset.meta.name)?_c('v-content',[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":"","lg3":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('search-datasets',{attrs:{"loading":_vm.loadingDatasetIndicator,"datasetsMeta":_vm.datasetsMeta.data}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm8":"","lg9":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"cyan elevation-0",attrs:{"dark":""}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Anonymisierung")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","loading":_vm.loadingColorisingCells},nativeOn:{"click":function($event){return _vm.colorisePrivacyCells($event)}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("select_all")]),_vm._v("\n                Personenbezogene Daten markieren\n              ")],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","disabled":!_vm.colorisedPrivacyCells,"loading":_vm.loadingAnonymisingCells},nativeOn:{"click":function($event){return _vm.anonymiseCells($event)}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("fingerprint")]),_vm._v("\n                Anonymisieren\n              ")],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","loading":_vm.refreshingTable},nativeOn:{"click":function($event){return _vm.clearFormatting($event)}}},[_c('v-icon',[_vm._v("refresh")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("more_vert")])],1)],1),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticClass:"body-2 grey--text"},[_vm._v("Wählen Sie eine der Funktionen aus, um fortzufahren.")])])]),_vm._v(" "),(_vm.loadingDatasetIndicator)?_c('v-card-text',{staticStyle:{"height":"500px"}},[_c('v-progress-circular',{staticClass:"loading-dataset-indicator",attrs:{"indeterminate":""}})],1):(!_vm.currentDataset.dataset.data)?_c('v-card-text',{staticStyle:{"height":"500px"}},[_vm._v("\n              Keine Daten\n            ")]):_c('v-card-text',[_c('Spreadsheet',{ref:"spread",attrs:{"root":_vm.root,"settings":_vm.currentDataset.dataset}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","color":"primary"}},[_vm._v("Änderungen speichern")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""}},[_vm._v("Abbrechen")])],1)],1)],1)],1)],1)],1):_c('v-content',[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('search-datasets',{attrs:{"loading":_vm.loadingDatasetIndicator,"datasetsMeta":_vm.datasetsMeta.data,"show-hint":true}})],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(32);






// Make vue aware of Vuex
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: {
    users: [{
      userId: 1,
      avatar: 'https://randomuser.me/api/portraits/men/85.jpg',
      fullname: 'Martin Müller',
      email: 'martin.mueller@oe1.de',
      role: 'user'
    }, { divider: true,
      inset: true
    }, { userId: 2,
      avatar: 'https://randomuser.me/api/portraits/women/85.jpg',
      fullname: 'Erika Musterfrau',
      email: 'jane.doe@oe1.de',
      role: 'user'
    }, { divider: true,
      inset: true
    }, { userId: 3,
      avatar: 'https://randomuser.me/api/portraits/women/86.jpg',
      fullname: 'Referatsleitung',
      email: 'referatsleitung@oe1.de',
      role: 'referatsleitung'
    }],
    currentUser: {
      loggedIn: true,
      userId: 1,
      avatar: 'https://randomuser.me/api/portraits/men/85.jpg',
      fullname: 'Martin Müller',
      email: 'martin.mueller@oe1.de',
      role: 'user'
    },
    datasetsMeta: {
      sortIndicator: true,
      columnSorting: true,
      manualColumnResize: true,
      colWidths: 100,
      height: 600,
      contextMenu: true,
      rowHeaders: true,
      colHeaders: ['ID', 'Quelle', 'Name', 'Beschreibung', 'Erstellt am', 'Zuletzt bearbeitet', 'Sprache', 'Kontakt', 'Autor', 'Status Erfassung', 'Status Bewertung', 'Status Aufwertung', 'Status Anonymisierung', 'Status Sichtbarkeit'],
      data: [{
        id: '21e9ym28',
        source: '',
        name: 'Breitbandzugang nach Stadt',
        description: 'Anzahl der Haushalte mit Breitbandzugang, aufgeschlüsselt nach Stadt.',
        date: {
          created: '09.11.2017',
          modified: '09.01.2018'
        },
        language: 'Deutsch',
        contact: 'BMI',
        author: 'John Doe',
        status: {
          stepErfassung: true,
          stepBewertung: true,
          stepAufwertung: false,
          stepAnonymisierung: false,
          visibility: 'Unveröffentlicht'
        },
        bewertung: {
          maschinenlesbarkeit: '',
          auffindbarkeit: '',
          nutzungsbedingungen: '',
          verfuegbarkeit: '',
          offeneStandards: '',
          aktualisierungsrate: ''
        }
      }, {
        id: 'xdq28pd',
        source: '',
        name: 'Studienerfolgsquote von Deutschen und Bildungsinländer/-innen',
        description: 'Studienerfolgsquote von Deutschen und Bildungsinländer/-innen in NRW und Deutschland in den Prüfungsjahren 2009 – 2014 nach Geschlecht und Beginn des Studiums',
        date: {
          created: '05.08.2017',
          modified: '08.08.2017'
        },
        language: 'Deutsch',
        contact: 'NRW',
        author: 'John Doe',
        status: {
          stepErfassung: false,
          stepBewertung: false,
          stepAufwertung: false,
          stepAnonymisierung: false,
          visibility: 'Unveröffentlicht'
        },
        bewertung: {
          maschinenlesbarkeit: '',
          auffindbarkeit: '',
          nutzungsbedingungen: '',
          verfuegbarkeit: '',
          offeneStandards: '',
          aktualisierungsrate: ''
        }
      }, {
        id: 'h31r08s',
        source: 'BLE - EU-Agrarfonds',
        name: 'EU Farm subsidies for Germany in 2013',
        description: 'This dataset lists farm subsidy payments made in Germany as published directly by the government of Germany or sourced via freedom of information requests. Germany is 19th in our transparency index which measures how good governments are at opening up their data to the general public.',
        date: {
          created: '05.02.2013',
          modified: '01.03.2014'
        },
        language: 'English',
        contact: 'Bundesanstalt für Landwirtschaft und Ernährung',
        author: 'FarbSubsidy.org',
        status: {
          stepErfassung: true,
          stepBewertung: true,
          stepAufwertung: true,
          stepAnonymisierung: false,
          visibility: 'Unveröffentlicht'
        },
        bewertung: {
          maschinenlesbarkeit: '',
          auffindbarkeit: '',
          nutzungsbedingungen: '',
          verfuegbarkeit: '',
          offeneStandards: '',
          aktualisierungsrate: ''
        }
      }]
    },
    datasets: [{
      id: 'peq2sad',
      stretchH: 'all',
      sortIndicator: true,
      columnSorting: true,
      contextMenu: true,
      rowHeaders: true,
      minRows: 10,
      manualColumnResize: true,
      colWidths: 100,
      colHeaders: ['ID', 'Name', 'Bezirk', 'Datum', 'Sicht', 'Temperatur', 'Profil', 'RSS-Name', 'BSL', 'Algen', 'Wasserqualität'],
      data: [['2', 'Alter Hof', 'Steglitz-Zehlendorf', '2017-09-12', '150', '18,10', 'Unterhavel', 'Alter Hof / Unterhavel', 'B334', '1', '1'], ['3', 'Alter Hof', 'Steglitz Zehlendorf', '2017-09-12', '150', '18,10', 'Unterhavel', 'Alter Hof/Unterhavel', 'B334', '1', '1'], ['4', 'Bammelecke', 'Treptow-Köpenick', '2017-09-05', '60', '20,10', 'Dahme', 'Bammelecke', 'B225', '1', '1']]
    }, {
      id: 'xdq28pd',
      stretchH: 'all',
      sortIndicator: true,
      columnSorting: true,
      contextMenu: true,
      rowHeaders: true,
      manualColumnResize: true,
      colWidths: 100,
      height: 600,
      colHeaders: ['Prüfungsjahr', 'Geschlecht', 'Beginn des Studiums', 'insgesamt', 'Deutsche', 'Bildungsinländer/-innen'],
      data: [['2013', 'weiblich', '2002', '77,5', '78,1', '58,3'], ['2013', 'weiblich', '2003', '77,2', '77,9', '57,4'], ['2013', 'weiblich', '2004', '81,1', '81,7', '63,3'], ['2013', 'weiblich', '2005', '80,9', '81,6', '61,1'], ['2014', 'Insgesamt', '2002', '75,9', '76,5', '57,2'], ['2014', 'Insgesamt', '2003', '75,2', '75,9', '55,7'], ['2014', 'Insgesamt', '2004', '77,8', '78,5', '59,4'], ['2014', 'Insgesamt', '2005', '77,5', '78,1', '59,8'], ['2014', 'Insgesamt', '2006', '79,0', '79,6', '62,2'], ['2014', 'männlich', '2002', '74,4', '75,0', '56,4'], ['2014', 'männlich', '2003', '73,6', '74,2', '54,5'], ['2014', 'männlich', '2004', '74,8', '75,5', '55,9'], ['2014', 'männlich', '2005', '73,9', '74,4', '57,7'], ['2014', 'männlich', '2006', '74,5', '75,0', '59,5'], ['2014', 'weiblich', '2002', '77,3', '78,0', '58,1'], ['2014', 'weiblich', '2003', '77,0', '77,7', '56,9'], ['2014', 'weiblich', '2004', '81,0', '81,6', '63,5'], ['2014', 'weiblich', '2005', '81,1', '81,8', '62,0'], ['2014', 'weiblich', '2006', '83,6', '84,2', '65,4']]
    }, {
      id: 'h31r08s',
      stretchH: 'all',
      height: 900,
      sortIndicator: true,
      columnSorting: true,
      contextMenu: true,
      rowHeaders: true,
      manualColumnResize: true,
      colWidths: 100,
      colHeaders: ['Zahlungsempfänger', 'Postleitzahl', 'Ort', 'Betrag in Euro', 'Jahr', 'Land'],
      data: [['Luettichauer Agrar GmbH', 'DE-01561', 'Thiendorf', '104927.92', '2013', 'DE'], ['MAP Meißener Agrarprodukte AG', 'DE-01561', '', '259853.32', '2013', 'DE'], ['Priestewitzer Agrarprodukte GmbH', 'DE-01561', 'Priestewitz', '254537.21', '2013', 'DE'], ['Saechsische Milcherzeugergenossenschaft Quersa e.G.', 'DE-01561', 'Lampertswalde', '526617.05', '2013', 'DE'], ['Schweinemastbetrieb Bauda GmbH', 'DE-01561', 'Grossenhain', '138684.93', '2013', 'DE'], ['AG Uchtdorf e.G.', 'DE-39517', '', '244264.6', '2013', 'DE'], ['AG Vietznitz eG', 'DE-14662', '', '313159.52', '2013', 'DE'], ['AG Werenzhain eG', 'DE-03253', '', '532058.22', '2013', 'DE'], ['AG Wörlitz eG', 'DE-06785', '', '880158.03', '2013', 'DE'], ['Schulverband Hohenlockstedt', 'DE-25551', 'Hohenlockstedt', '118181.82', '2013', 'DE'], ['Amt Wilstermarsch', 'DE-25554', '', '8525', '2013', 'DE'], ['Flurbereinigung Nortorf II Teilnehmergemeinschaft', 'DE-25554', '', '124379.49', '2013', 'DE'], ['Gemeinde Hanerau-Hademarschen Amt Hanerau-Hademarschen', 'DE-25557', '', '107000', '2013', 'DE'], ['Gemeinde Holstenniendorf', 'DE-25560', 'Schenefeld', '82944.54', '2013', 'DE'], ['Jan Rijpma GmbH', 'DE-26736', '', '2466.45', '2013', 'DE'], ['Borkumer Weidegenoss. eG', 'DE-26757', '', '30238.57', '2013', 'DE'], ['Reitanlage Jütting GmbH', 'DE-26757', '', '516.95', '2013', 'DE'], ['Ev. ref. Kirchengemeinde Loppersum', 'DE-26759', 'Hinte', '85592', '2013', 'DE'], ['Landkreis Leer', 'DE-26789', '', '108021.81', '2013', 'DE'], ['Leda-Jümme-Verband', 'DE-26789', '', '1458.8', '2013', 'DE']]
    }],
    currentDataset: {
      meta: {},
      dataset: {}
    },
    status: {
      demoUploadedFiles: false,
      loading: false,
      loadingDataset: false,
      finished: false,
      notifications: []
    }
  },
  actions: {
    // An action receives the commit from the components and
    // commits a new event to the mutations
    loadResource: function loadResource(_ref, resourceIdentifier) {
      var commit = _ref.commit,
          state = _ref.state;

      if (state.currentDataset.meta.id !== resourceIdentifier) commit('LOADRESOURCE', resourceIdentifier);
      // router.push('/erfassung/' + resourceIdentifier)
    },
    loginUser: function loginUser(_ref2, userId) {
      var commit = _ref2.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        commit('LOGINUSER', userId);
        resolve();
      });
    },
    logoutUser: function logoutUser(_ref3) {
      var commit = _ref3.commit;

      commit('LOGOUTUSER');
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/login');
    },
    demoUploadDatasetMeta: function demoUploadDatasetMeta(_ref4) {
      var commit = _ref4.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var demoDatesetMeta = {
          id: 'peq2sad',
          name: 'Liste der Berliner Badestellen',
          source: 'Landesamt für Gesundheit und Soziales',
          description: 'Landesamt für Gesundheit und Soziales',
          date: {
            created: '05.08.2017',
            modified: '08.08.2017'
          },
          language: 'Deutsch',
          contact: 'Landesamt für Gesundheit und Soziales',
          author: 'John Doe',
          status: {
            stepErfassung: true,
            stepBewertung: true,
            stepAufwertung: false,
            stepAnonymisierung: false,
            visibility: 'Unveröffentlicht'
          },
          bewertung: {
            maschinenlesbarkeit: '',
            auffindbarkeit: '',
            nutzungsbedingungen: '',
            verfuegbarkeit: '',
            offeneStandards: '',
            aktualisierungsrate: ''
          }
        };

        commit('DEMOUPLOADDATASETMETA', demoDatesetMeta);

        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/erfassung/' + demoDatesetMeta.id);
        resolve(demoDatesetMeta);
      });
    },
    addNotification: function addNotification(_ref5, notificationContent) {
      var commit = _ref5.commit;

      commit('ADDNOTIFICATION', notificationContent);
    }
  },
  mutations: {
    // A mutation receives the current state as the first argument
    // You can make any modifications you want inside this function
    LOADRESOURCE: function LOADRESOURCE(state, resourceIdentifier) {
      // Receives a resourceId, resourceName or resourceObject and loads requested resource
      state.status.loadingDataset = true;
      state.currentDataset.meta = '';
      state.currentDataset.data = '';

      for (var i = state.datasetsMeta.data.length - 1; i >= 0; i--) {
        if (state.datasetsMeta.data[i].id === resourceIdentifier) {
          state.currentDataset.meta = state.datasetsMeta.data[i];
        }
      }

      state.currentDataset.dataset = '';
      for (var j = state.datasets.length - 1; j >= 0; j--) {
        if (state.datasets[j].id === resourceIdentifier) {
          state.currentDataset.dataset = state.datasets[j];
        }
      }
      setTimeout(function () {
        state.status.loadingDataset = false;
      }, 600);
    },
    LOGINUSER: function LOGINUSER(state, userId) {
      state.status.loading = true;
      for (var i = state.users.length - 1; i >= 0; i--) {
        if (state.users[i].userId === userId) {
          state.currentUser = state.users[i];
        }
      }
      state.currentUser.loggedIn = true;
      state.status.loading = false;
    },
    LOGOUTUSER: function LOGOUTUSER(state) {
      state.currentUser = {
        loggedIn: false
      };
    },
    DEMOUPLOADDATASETMETA: function DEMOUPLOADDATASETMETA(state, demoDatesetMeta) {
      state.datasetsMeta.data.push(demoDatesetMeta);
    },
    ADDNOTIFICATION: function ADDNOTIFICATION(state, notificationContent) {
      state.status.notifications.push(notificationContent);
    }
  },
  getters: {
    getState: function getState(state) {
      return state;
    },
    getUsers: function getUsers(state) {
      return state.users;
    },
    getCurrentUser: function getCurrentUser(state) {
      return state.currentUser;
    },
    getDatasetsMeta: function getDatasetsMeta(state) {
      return state.datasetsMeta;
    },
    getCurrentDataset: function getCurrentDataset(state) {
      return state.currentDataset;
    },
    getLoadingDatasetIndicator: function getLoadingDatasetIndicator(state) {
      return state.status.loadingDataset;
    },
    getIsReferatsleitung: function getIsReferatsleitung(state) {
      if (state.currentUser.role === 'referatsleitung') return true;
      return false;
    },
    getStatus: function getStatus(state) {
      return state.status;
    },
    getNotifications: function getNotifications(state) {
      return state.status.notifications;
    }
  }
}));

/***/ }),

/***/ 30:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FooterArrows__ = __webpack_require__(183);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    currentUser: function currentUser() {
      return this.$store.getters.getCurrentUser;
    },
    currentDataset: function currentDataset() {
      return this.$store.getters.getCurrentDataset;
    },
    isReferatsleitung: function isReferatsleitung() {
      return this.$store.getters.getIsReferatsleitung;
    }
  },
  components: {
    FooterArrows: __WEBPACK_IMPORTED_MODULE_0__components_FooterArrows__["a" /* default */]
  },
  data: function data() {
    return {
      drawer: true,
      drawerItems: [{ icon: 'dashboard', title: 'Dashboard', link: '/dashboard' }, { icon: 'settings', title: 'Einstellungen', link: '/settings' }],
      drawerTools: [{
        action: 'work',
        title: 'Tools',
        active: true,
        items: [{ title: 'Erfassung', link: '/erfassung/' }, { title: 'Bewertung', link: '/bewertung/' }, { title: 'Aufwertung', link: '/aufwertung/' }, { title: 'Anonymisierung', link: '/anonymisierung/' }]
      }],
      miniVariant: false,
      sheet: false,
      dialog: false,
      loadingIndicator: false
    };
  },

  methods: {
    logoutUser: function logoutUser() {
      this.$store.dispatch('logoutUser');
    },
    publishDataset: function publishDataset() {
      this.loadingIndicator = true;
      var that = this;
      setTimeout(function () {
        that.currentDataset.meta.status.visibility = 'Veröffentlicht';
        that.loadingIndicator = false;
        that.sheet = false;
        that.dialog = true;
      }, 1400);
    }
  }
});

/***/ }),

/***/ 31:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    currentDataset: function currentDataset() {
      return this.$store.getters.getCurrentDataset;
    },
    backButton: function backButton() {
      for (var i = this.steps.length - 1; i >= 0; i--) {
        if (this.steps[i] === this.$route.name && i - 1 >= 0) return this.steps[i - 1];
      }
      return '';
    },
    nextButton: function nextButton() {
      for (var i = this.steps.length - 1; i >= 0; i--) {
        if (this.steps[i] === this.$route.name && i + 1 <= this.steps.length - 1) return this.steps[i + 1];
      }
      return '';
    }
  },
  data: function data() {
    return {
      steps: ['Erfassung', 'Bewertung', 'Aufwertung', 'Anonymisierung']
    };
  },

  methods: {
    login: function login(userId) {
      var _this = this;

      this.$store.dispatch('loginUser', userId).then(function () {
        _this.$router.push('/dashboard');
      });
    }
  }
});

/***/ }),

/***/ 32:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Login__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Dashboard__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Erfassung__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Bewertung__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Aufwertung__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Anonymisierung__ = __webpack_require__(279);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    redirect: '/login'
  }, {
    path: '/dashboard',
    name: 'Dashboard',
    component: __WEBPACK_IMPORTED_MODULE_3__views_Dashboard__["a" /* default */],
    meta: {
      title: 'Dashboard',
      requiresAuth: true
    }
  }, {
    path: '/erfassung/:id?',
    name: 'Erfassung',
    component: __WEBPACK_IMPORTED_MODULE_4__views_Erfassung__["a" /* default */],
    meta: {
      title: 'Erfassung',
      requiresAuth: true
    }
  }, {
    path: '/bewertung/:id?',
    name: 'Bewertung',
    component: __WEBPACK_IMPORTED_MODULE_5__views_Bewertung__["a" /* default */],
    meta: {
      title: 'Bewertung',
      requiresAuth: true
    }
  }, {
    path: '/aufwertung/:id?',
    name: 'Aufwertung',
    component: __WEBPACK_IMPORTED_MODULE_6__views_Aufwertung__["a" /* default */],
    meta: {
      title: 'Aufwertung',
      requiresAuth: true
    }
  }, {
    path: '/anonymisierung/:id?',
    name: 'Anonymisierung',
    component: __WEBPACK_IMPORTED_MODULE_7__views_Anonymisierung__["a" /* default */],
    meta: {
      title: 'Anonymisierung',
      requiresAuth: true
    }
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Login__["a" /* default */]
  }, {
    path: '/sign-out',
    redirect: '/login'
  }]
}));

/***/ }),

/***/ 33:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    users: function users() {
      return this.$store.getters.getUsers;
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    login: function login(userId) {
      var _this = this;

      this.$store.dispatch('loginUser', userId).then(function () {
        _this.$router.push('/dashboard');
      });
    }
  }
});

/***/ }),

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    datasetsMeta: function datasetsMeta() {
      return this.$store.getters.getDatasetsMeta.data;
    },
    isReferatsleitung: function isReferatsleitung() {
      return this.$store.getters.getIsReferatsleitung;
    },
    notifications: function notifications() {
      return this.$store.getters.getNotifications;
    },
    numberOfNotifications: function numberOfNotifications() {
      if (this.notifications) return this.notifications.length;
      return 0;
    }
  },
  data: function data() {
    return {
      headers: [{
        text: 'Name des Datensatzes',
        align: 'left',
        value: 'name'
      }, { text: 'Zuletzt bearbeitet', value: 'date' }, { text: 'Erfassung', align: 'center', value: 'status.stepErfassung' }, { text: 'Bewertung', align: 'center', value: 'status.stepBewertung' }, { text: 'Aufwertung', align: 'center', value: 'status.stepAufwertung' }, { text: 'Anonymisierung', align: 'center', value: 'status.stepAnonymisierung' }, { text: 'Status', value: 'status' }],
      selected: [],
      viewAsGrid: false,
      showNotificationCenter: false
    };
  },

  methods: {
    removeNotification: function removeNotification(index) {
      this.notifications.slice(index, 1);
    }
  },
  filters: {
    ellipsis: function ellipsis(string) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;

      if (string) {
        if (string.length > length) return string.substring(0, length) + '...';
      }
      return string;
    }
  }
});

/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_handsontable_official__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_IntelligentMetadataScanner__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SearchDatasets__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    currentDataset: function currentDataset() {
      return this.$store.getters.getCurrentDataset;
    },
    datasetsMeta: function datasetsMeta() {
      return this.$store.getters.getDatasetsMeta;
    },
    loadingDatasetIndicator: function loadingDatasetIndicator() {
      return this.$store.getters.getLoadingDatasetIndicator;
    }
  },
  components: {
    Spreadsheet: __WEBPACK_IMPORTED_MODULE_0_vue_handsontable_official__["default"],
    IntelligentMetadataScanner: __WEBPACK_IMPORTED_MODULE_1__components_IntelligentMetadataScanner__["a" /* default */],
    SearchDatasets: __WEBPACK_IMPORTED_MODULE_2__components_SearchDatasets__["a" /* default */]
  },
  data: function data() {
    return {
      root: 'test-hot',
      metaDataUploadDialog: false,
      currentLanguage: 'de',
      e: [],
      element: [],
      fields: [
      /* eslint-disable */
      {
        "type": "text",
        "nodetype": "LITERAL",
        "property": "dcatde:contributorID",
        "cardinality": {
          "min": 1,
          "max": 1
        },
        "label": {
          "en": "Data identifier",
          "de": "Datenbereitsteller-ID"
        },
        "description": {
          "en": "A short title of the resource.",
          "de": "Ein kurzer Titel der Ressource."
        },
        "styles": ["nonEditable"]
      }, {
        "type": "text",
        "nodetype": "LANGUAGE_LITERAL",
        "property": "dct:title",
        "cardinality": {
          "min": 1,
          "max": 1
        },
        "label": {
          "en": "Title",
          "de": "Titel"
        },
        "description": {
          "en": "A short title of the resource.",
          "de": "Ein kurzer Titel der Ressource."
        }
      }, {
        "type": "text",
        "nodetype": "DATATYPE_LITERAL",
        "property": "dct:description",
        "cardinality": {
          "min": 1,
          "pref": "1",
          "max": 1
        },
        "label": {
          "en": "Description",
          "de": "Beschreibung"
        },
        "description": {
          "en": "A description for this resource.",
          "de": "Eine Beschreibung dieser Ressource."
        }
      }, {
        "type": "text",
        "nodetype": "DATATYPE_LITERAL",
        "property": "dct:modified",
        "datatype": "xsd:date",
        "cardinality": {
          "min": 1,
          "pref": "1",
          "max": 1
        },
        "label": {
          "en": "Date",
          "de": "Datum"
        },
        "description": {
          "en": "A date when this resource was modified.",
          "de": "Ett datum när denna resurs modifierades."
        },
        "styles": ["autoUpdateDate", "nonEditable"]
      }, {
        "type": "text",
        "nodetype": "DATATYPE_LITERAL",
        "property": "dct:date",
        "datatype": "xsd:date",
        "cardinality": {
          "min": 1,
          "pref": "1",
          "max": 1
        },
        "label": {
          "en": "Date",
          "de": "Datum"
        },
        "description": {
          "en": "A date for this resource.",
          "de": "Ein Datum für diese Ressource."
        },
        "styles": ["autoInitDate"]
      }, {
        "id": "subject",
        "type": "choice",
        "nodetype": "URI",
        "property": "http://publications.europa.eu/mdr/resource/authority/data-theme/xml/data-theme.xml",
        "cardinality": {
          "min": 1,
          "pref": "1",
          "max": 2
        },
        "choices": [{
          "value": "AGRI",
          "label": {
            "en": "Agriculture, fisheries, forestry and food",
            "de": "Landwirtschaft, Fischerei, Forstwirtschaft und Nahrungsmittel"
          }
        }, {
          "value": "ECON",
          "label": {
            "en": "Economy and finance",
            "de": "Wirtschaft und Finanzen"
          }
        }, {
          "value": "EDUC",
          "label": {
            "en": "Education, culture and sport",
            "de": "Bildung, Kultur und Sport"
          }
        }, {
          "value": "ENER",
          "label": {
            "en": "Energy",
            "de": "Energie"
          }
        }, {
          "value": "ENVI",
          "label": {
            "en": "Environment",
            "de": "Umwelt"
          }
        }, {
          "value": "GOVE",
          "label": {
            "en": "Government and public sector",
            "de": "Regierung und öffentlicher Sektor"
          }
        }, {
          "value": "HEAL",
          "label": {
            "en": "Health",
            "de": "Gesundheit"
          }
        }, {
          "value": "INTR",
          "label": {
            "en": "International issues",
            "de": "Internationale Themen"
          }
        }, {
          "value": "JUST",
          "label": {
            "en": "Justice, legal system and public safety",
            "de": "Justiz, Rechtssystem und öffentliche Sicherheit"
          }
        }, {
          "value": "REGI",
          "label": {
            "en": "Regions and cities",
            "de": "Regionen und Städte"
          }
        }, {
          "value": "SOCI",
          "label": {
            "en": " Population and society",
            "de": "Bevölkerung und Gesellschaft"
          }
        }, {
          "value": "TECH",
          "label": {
            "en": "Science and technology",
            "de": "Wissenschaft und Technologie"
          }
        }, {
          "value": "TRAN",
          "label": {
            "en": "Transport",
            "de": "Verkehr"
          }
        }],
        "label": {
          "en": "Subject",
          "de": "Thema"
        },
        "description": {
          "en": "A subject for this resource.",
          "de": "Eine Thema für diese Ressource."
        }
      }, {
        "type": "choice",
        "nodetype": "URI",
        "property": "http://purl.org/dc/terms/license",
        "cardinality": {
          "min": 1,
          "pref": 1,
          "max": 1
        },
        "choices": [{
          "value": "cc:by/4.0/",
          "label": {
            "en": "CC BY 4.0 (Attribution)"
          }
        }, {
          "value": "cc:by-nc/4.0/",
          "label": {
            "en": "CC BY-NC 4.0 (Attribution, Non-Commercial)"
          }
        }],
        "styles": ["verticalRadioButtons"],
        "label": {
          "en": "License",
          "de": "Lizenz"
        },
        "description": {
          "en": "A license for this resource.",
          "de": "Eine Lizenz für diese Ressource."
        }
      }]
    };
  },

  methods: {}
});

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handsontable = __webpack_require__(20);

var _handsontable2 = _interopRequireDefault(_handsontable);

var _settingsMapper = __webpack_require__(156);

var _settingsMapper2 = _interopRequireDefault(_settingsMapper);

var _helpers = __webpack_require__(264);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'HotTable',
  props: _helpers.propFactory.call(undefined),
  watch: _helpers.propWatchFactory.call(undefined, _helpers.updateHotSettings, _helpers.updateBulkHotSettings),
  mounted: function mounted() {
    return _helpers.hotInit.call(this);
  },
  beforeDestroy: function beforeDestroy() {
    return _helpers.hotDestroy.call(this);
  }
}; //
//
//
//

/***/ })

},[176]);


// WEBPACK FOOTER //
// static/js/app.ccc602a3979b83e182d2.js